/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionLanguageEnum } from './InformationExtractionLanguageEnum';
import {
  InformationExtractionLanguageEnumFromJSON,
  InformationExtractionLanguageEnumFromJSONTyped,
  InformationExtractionLanguageEnumToJSON,
} from './InformationExtractionLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';

/**
 *
 * @export
 * @interface PerturbedInformationExtractionDataset
 */
export interface PerturbedInformationExtractionDataset {
  /**
   *
   * @type {number}
   * @memberof PerturbedInformationExtractionDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedInformationExtractionDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedInformationExtractionDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedInformationExtractionDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedInformationExtractionDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {Array<number>}
   * @memberof PerturbedInformationExtractionDataset
   */
  documents?: Array<number>;
  /**
   *
   * @type {number}
   * @memberof PerturbedInformationExtractionDataset
   */
  schema: number;
  /**
   *
   * @type {InformationExtractionLanguageEnum}
   * @memberof PerturbedInformationExtractionDataset
   */
  language: InformationExtractionLanguageEnum;
}

/**
 * Check if a given object implements the PerturbedInformationExtractionDataset interface.
 */
export function instanceOfPerturbedInformationExtractionDataset(
  value: object,
): value is PerturbedInformationExtractionDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('schema' in value) || value['schema'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedInformationExtractionDatasetFromJSON(json: any): PerturbedInformationExtractionDataset {
  return PerturbedInformationExtractionDatasetFromJSONTyped(json, false);
}

export function PerturbedInformationExtractionDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedInformationExtractionDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    documents: json['documents'] == null ? undefined : json['documents'],
    schema: json['schema'],
    language: InformationExtractionLanguageEnumFromJSON(json['language']),
  };
}

export function PerturbedInformationExtractionDatasetToJSON(
  value?: Omit<PerturbedInformationExtractionDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    documents: value['documents'],
    schema: value['schema'],
    language: InformationExtractionLanguageEnumToJSON(value['language']),
  };
}
